export default __webpack_public_path__ + "static/media/Nano.a35bb616.png";